import React, { useEffect } from "react";

import { Box, Button, Typography } from "@braintrust/braintrust-ui-components";
import { useUser } from "@js/apps/common/hooks";
import { ModalInstance } from "@js/components/modal";

import { useSignUpEmailConfirmPage } from "../../hooks/sign-up-confirm";

import style from "./style.module.scss";

const DEFAULT_TITLE = "Click the link in your email!";

type SignUpConfirmationContentProps = {
  title?: string;
  align?: "center" | "left" | "right";
  envelopeIcon?: React.ReactNode;
};

export const SignUpConfirmationContent = ({
  title = DEFAULT_TITLE,
  align = "left",
  envelopeIcon,
}: SignUpConfirmationContentProps) => {
  const { email, handleEmailResend } = useSignUpEmailConfirmPage();

  if (!email) return null;

  return (
    <>
      <Box sx={{ textAlign: align }}>
        {envelopeIcon ? (
          envelopeIcon
        ) : (
          <img
            src={`${SETTINGS.STATIC_URL}onboarding/mail.svg`}
            alt="Email"
            width={92}
            height={92}
          />
        )}
      </Box>
      <Box sx={{ textAlign: align }}>
        <Typography
          component="h1"
          variant="title"
          fontWeight={400}
          sx={{ mt: 3, mb: 2 }}
        >
          {title}
        </Typography>
        <Typography component="p">
          Click the link in the email we just sent to{" "}
          <Typography component="span" fontWeight={500} underline="yellow">
            {email}
          </Typography>
          <br />
          to verify your new Braintrust account. If you don’t see an email
          within 15 minutes,
          <br />
          check your spam folder or try to{" "}
          <Button
            variant="transparent"
            className={style.resendButton}
            onClick={handleEmailResend}
          >
            resend the email
          </Button>
          .
        </Typography>
      </Box>
    </>
  );
};

export const openEmailConfirmationModal = (onClose?: () => void) => {
  ModalInstance.open({
    padding: true,
    closeButton: true,
    children: <EmailConfirmationModalContent />,
    onClose,
  });
};

const closeEmailConfirmationModal = () => {
  ModalInstance.close();
};

const EmailConfirmationModalContent = () => {
  const user = useUser();
  const isUserVerified = !!user?.is_verified;
  useEffect(() => {
    if (!isUserVerified) {
      return;
    }

    closeEmailConfirmationModal();
  }, [isUserVerified]);

  return <SignUpConfirmationContent align="center" />;
};
